import styles from './ReferralDisclaimer.module.css';
import { useReferralCode } from '../../hooks/useReferralCode';

export function ReferralDisclaimer() {
  const { referrerName, error: referrerError } = useReferralCode();

  if (referrerError !== null) {
    return (
      <>
        <h1 className={styles.header}>
          Oops, it looks like the referral link you're using is not correct.
        </h1>
        <p className={styles.description}>
          Please double check the link & try again
        </p>
      </>
    );
  }

  if (referrerName) {
    return (
      <>
        <h1 className={styles.header}>Sign-up for iwocaPay and share £200</h1>
        <p className={styles.description}>
          {referrerName} thought you could use iwocaPay. Get a personalised pay
          link and add it anywhere you take payments: invoices, emails,
          websites, texts. Once you are set up to offer iwocaPay, you both get a
          £100 voucher of your choice.
        </p>
      </>
    );
  }

  return null;
}
